import backend, {DIALPAD_INTEGRATION_API} from 'utils/backend/server/api_library';


const createDialpadLink = (userRn, phoneNumber) => {
  const url = `${DIALPAD_INTEGRATION_API}/dialpad/integeration/client`;
  const body = {
    userRn,
    phoneNumber,
  };
  return backend.post(url, body);
};

const getDialpadLink = (userRn) => {
  const url = `${DIALPAD_INTEGRATION_API}/dialpad/integeration/client/${userRn}`;
  return backend.get(url);
};

export default {
  createDialpadLink,
  getDialpadLink,
};
